import { FC, useState } from 'react';

import { Button } from '@/components/button.tsx';
import SuccessModal from '@/components/Modals/SuccessModal';

import { resumeCase } from '@/app/api';
import ErrorModal from '@/components/Modals/ErrorModal';

import { useAppDispatch } from '@/store/store';
import { fetchStartet } from '@/store/slices/startetSlice';

interface IPauseCell {
  id: number;
}

const PauseCell: FC<IPauseCell> = ({ id }) => {
  const [isOpenSuccess, setIsOpenSuccess] = useState<boolean>(false);
  const [isOpenError, setIsOpenError] = useState<boolean>(false);
  const [errors, setErrors] = useState<string>('');

  const dispatch = useAppDispatch();

  const handleFetch = () => {
    dispatch(fetchStartet());
  };

  const handlePause = () => {
    setIsOpenSuccess(false);
    setIsOpenError(false);

    resumeCase(id)
      .then(() => setIsOpenSuccess(true))
      .catch((error) => {
        setIsOpenError(true);
        setErrors(error?.response?.data?.message);
      });
  };

  return (
    <>
      <Button
        onClick={handlePause}
        className={
          'bg-[#979A9B] hover:bg-[rgba(31,43,64,1)] transition-[200ms] w-full max-w-[149px]'
        }>
        Pauset
      </Button>

      <SuccessModal
        isOpen={isOpenSuccess}
        setIsOpen={setIsOpenSuccess}
        action={handleFetch}
        title="Rykkerproces startet"
      />
      <ErrorModal
        isOpen={isOpenError}
        setIsOpen={setIsOpenError}
        errors={errors}
      />
    </>
  );
};

export default PauseCell;
